import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';
import { parseColor } from '../../styles';
import { ENV_COLORS } from '../../tokens/ENV_COLORS';
import { envConfig } from '../../utils/envConfig';
import { SVGIcon } from '../Icons';

export const StackedTalosLogo = ({
  fill = 'gray.100',
  showLabel,
  ref,
  ...props
}: { showLabel?: boolean } & SVGProps<SVGElement>) => {
  const theme = useTheme();
  const fillColor = parseColor(theme, fill);
  const envColor = parseColor(theme, ENV_COLORS[envConfig.VITE_AVA_ENV]);
  return (
    <SVGIcon
      {...props}
      width={showLabel ? 52 : 20}
      height={showLabel ? 30 : 20}
      viewBox={showLabel ? `0 0 52 30` : `17 0 17 17`}
    >
      <path d="M22.4726 11.5274H18V16H22.4726V11.5274Z" fill={fillColor} />
      <path d="M28.2314 11.5274H23.7588V16H28.2314V11.5274Z" fill={fillColor} />
      <path d="M22.4726 5.76764H18V10.2402H22.4726V5.76764Z" fill={fillColor} />
      <path d="M34 0H29.5274V4.47259H34V0Z" fill={envColor ?? fillColor} />
      <path d="M28.2314 0H23.7588V4.47259H28.2314V0Z" fill={envColor ?? fillColor} />
      <path d="M34 5.76764H29.5274V10.2402H34V5.76764Z" fill={envColor ?? fillColor} />
      {showLabel && (
        <>
          <path
            fill={fillColor}
            d="M10.8991 22.584L10.2201 23.7515H8.84131V29.4063H7.55778V23.7515H5.5V22.584H10.8991Z"
          />
          <path
            fill={fillColor}
            d="M18.0537 22.584L19.9376 29.4063H18.6168L17.9088 26.7181L17.4202 27.8897H15.8386L15.4287 29.4104H14.1121L15.9959 22.584H18.0537ZM17.9088 26.7181L17.0849 23.656H16.9689L16.1409 26.7181H17.9088Z"
          />
          <path fill={fillColor} d="M25.5023 22.584V28.2388H27.9534L28.649 29.4104H24.2188V22.584H25.5023Z" />
          <path
            fill={fillColor}
            d="M34.5284 22.4467C36.2674 22.4467 37.3273 23.527 37.3273 25.272V26.7138C37.3273 28.5086 36.2674 29.539 34.5284 29.539C32.7894 29.539 31.7295 28.5045 31.7295 26.7138V25.272C31.7336 23.527 32.7894 22.4467 34.5284 22.4467ZM33.013 26.7761C33.013 27.7608 33.4975 28.3923 34.5284 28.3923C35.5884 28.3923 36.0438 27.7192 36.0438 26.7761V25.2139C36.0438 24.2499 35.4807 23.5976 34.5284 23.5976C33.5471 23.5976 33.013 24.2915 33.013 25.2139V26.7761Z"
          />
          <path
            fill={fillColor}
            d="M46.0346 24.6114V24.9022H44.7925V24.6987C44.7925 23.9176 44.2956 23.5769 43.5214 23.5769C42.8424 23.5769 42.4242 23.9176 42.4242 24.387C42.4242 25.031 43.0245 25.1474 43.8443 25.3344L43.9313 25.3551C45.3307 25.6667 46.1547 26.1653 46.1547 27.4035C46.1547 28.7787 45.0865 29.5474 43.6373 29.5474C41.977 29.5474 40.9088 28.6499 40.9088 27.0503V26.8342H42.1716V27.0088C42.1716 27.848 42.6478 28.4131 43.6787 28.4131C44.5027 28.4131 44.8919 27.9727 44.8919 27.4658C44.8919 26.8716 44.3867 26.6764 43.4924 26.4811L43.4055 26.4603C41.9977 26.1487 41.1614 25.6626 41.1614 24.4244C41.1614 23.2071 42.2006 22.4467 43.5214 22.4467C44.9747 22.4467 46.0346 23.2445 46.0346 24.6114Z"
          />
        </>
      )}
    </SVGIcon>
  );
};
